export default __webpack_public_path__ + "static/media/baby1.3349254e.jpg";